import { render, staticRenderFns } from "./noComponentFound.vue?vue&type=template&id=b44ad614&scoped=true&"
import script from "./noComponentFound.vue?vue&type=script&lang=js&"
export * from "./noComponentFound.vue?vue&type=script&lang=js&"
import style0 from "./noComponentFound.vue?vue&type=style&index=0&id=b44ad614&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44ad614",
  null
  
)

export default component.exports